import React, { useCallback, useEffect, useState } from "react";
import { Spinner } from "reactstrap";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { Block, BlockHead, BlockHeadContent, BlockTitle, BlockDes } from "../../components/Component";
import { handleGetApis } from "../../service/Api";
import SectionsTab from "./SectionsTab";
import FaqTab from "./FaqTab";
import SeoTab from "./SeoTab";
import "./homepageContent.css";

const TABS = [
  { key: "sections", label: "Sections" },
  { key: "faqs", label: "FAQs" },
  { key: "seo", label: "SEO" },
];

const HomepageContent = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [tab, setTab] = useState("sections");
  // Bumped after each save so tab forms remount with fresh server data.
  const [version, setVersion] = useState(0);

  const load = useCallback(async () => {
    const res = await handleGetApis("admin/homepage");
    if (res?.data?.success) {
      setData(res.data.data);
      setVersion((v) => v + 1);
      setError(false);
    } else {
      setError(true);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <>
      <Head title="Homepage Content" />
      <Content>
        <BlockHead size="sm">
          <BlockHeadContent>
            <BlockTitle page>Homepage Content</BlockTitle>
            <BlockDes className="text-soft">
              <p>Edit homepage copy, FAQs and SEO. Changes go live within a few minutes.</p>
            </BlockDes>
          </BlockHeadContent>
        </BlockHead>

        <div className="hc-tabs" role="tablist">
          {TABS.map((t) => (
            <button
              key={t.key}
              type="button"
              role="tab"
              aria-selected={tab === t.key}
              className={`hc-tab ${tab === t.key ? "is-active" : ""}`}
              onClick={() => setTab(t.key)}
            >
              {t.label}
            </button>
          ))}
        </div>

        <Block key={`${tab}-${version}`}>
          {error && <p className="text-danger">Could not load homepage content. Please refresh.</p>}
          {!data && !error && <Spinner color="primary" />}
          {data && tab === "sections" && <SectionsTab sections={data.sections} onSaved={load} />}
          {data && tab === "faqs" && <FaqTab faqs={data.faqs} onSaved={load} />}
          {data && tab === "seo" && <SeoTab seo={data.seo} onSaved={load} />}
        </Block>
      </Content>
    </>
  );
};

export default HomepageContent;
